module.exports = __webpack_public_path__ + "static/img/no_mer.e31ee6c1.png";